export default __webpack_public_path__ + "static/media/HARDIK DAWAR.f75a2326.jpg";